import script from "./TocItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TocItem.vue?vue&type=script&setup=true&lang=js"

import "./TocItem.vue?vue&type=style&index=0&id=61b8f153&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b8f153"]])

export default __exports__